/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.224.0-v202611042218-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

/**
 * The table definition for the table that was computed.
 */
export interface TableDefinitionOutputV1 {
    /**
     * Additional properties of the item
     */
    "additionalProperties"?: Array<models.ScalarPropertyV1>;
    /**
     * The behavior when the table receives batch updates
     */
    "batchAction": BatchActionEnum;
    /**
     * The Column Definitions for this Table Definition
     */
    "columnDefinitions": Array<models.ColumnDefinitionOutputV1>;
    "conditionMonitor"?: models.ConditionMonitorOutputV1;
    /**
     * The data ID of this asset. Note: This is not the Seeq ID, but the unique identifier that the remote datasource uses.
     */
    "dataId"?: string;
    /**
     * The datasource class, which is the type of system holding the item, such as OSIsoft PI
     */
    "datasourceClass"?: string;
    /**
     * The datasource identifier, which is how the datasource holding this item identifies itself
     */
    "datasourceId"?: string;
    /**
     * Clarifying information or other plain language description of this item
     */
    "description"?: string;
    "effectivePermissions"?: models.PermissionsV1;
    /**
     * The exports configured for the table
     */
    "exports"?: Array<models.ExportPreviewV1>;
    "filterSpec"?: models.FilterSpecV1;
    /**
     * The ID that can be used to interact with the item
     */
    "id": string;
    /**
     * Whether item is archived
     */
    "isArchived"?: boolean;
    /**
     * Whether item is redacted
     */
    "isRedacted"?: boolean;
    "itemFinder"?: models.ItemFinderOutputV1;
    /**
     * The human readable name
     */
    "name": string;
    /**
     * The navigation column id used for overriding the default Data tab column representation. The navigation column can only be set on Scaling or Scaling CSV table types. Only Text and Item columns can be used as navigation columns.
     */
    "navigationColumnId"?: string;
    /**
     * The ID of the workbook to which this item is scoped or null if it is in the global scope.
     */
    "scopedTo"?: string;
    /**
     * A plain language status message with information about any issues that may have been encountered during an operation
     */
    "statusMessage"?: string;
    "subscription"?: models.ItemPreviewV1;
    /**
     * The type of table
     */
    "tableType": TableTypeEnum;
    /**
     * The item's translation key, if any
     */
    "translationKey"?: string;
    /**
     * The type of the item
     */
    "type": string;
    /**
     * The Unique ID column name for the Table, if applicable
     */
    "uniqueIDColumnName"?: string;
    "vantage"?: models.ItemPreviewV1;
}

export const BatchActionEnum = {
    UPDATEEXISTINGINSERTNEWCLEANUP: 'UPDATE_EXISTING_INSERT_NEW_CLEANUP',
    UPDATEEXISTINGINSERTNEW: 'UPDATE_EXISTING_INSERT_NEW',
    ONLYUPDATEEXISTING: 'ONLY_UPDATE_EXISTING',
    ONLYINSERTNEW: 'ONLY_INSERT_NEW'
} as const;

export type BatchActionEnum = typeof BatchActionEnum[keyof typeof BatchActionEnum];
export const TableTypeEnum = {
    SCALING: 'SCALING',
    SCALINGCSV: 'SCALING_CSV',
    IMPACTREPORT: 'IMPACT_REPORT',
    VANTAGE: 'VANTAGE',
    CAPSULE: 'CAPSULE',
    GENERIC: 'GENERIC',
    FORMULAACROSS: 'FORMULA_ACROSS',
    ITEM: 'ITEM',
    ITEMCSV: 'ITEM_CSV',
    STORED: 'STORED'
} as const;

export type TableTypeEnum = typeof TableTypeEnum[keyof typeof TableTypeEnum];
